export default __webpack_public_path__ + "48275b88c6235a701979ab7e99b64e7e.svg";